import { render, staticRenderFns } from "./groups_explore_empty_state.vue?vue&type=template&id=28a13b53"
import script from "./groups_explore_empty_state.vue?vue&type=script&lang=js"
export * from "./groups_explore_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports